import { JsonValue } from 'type-fest';

const getInitialData = (key: string, defaultFallback?: JsonValue) => {
  if (typeof window !== 'undefined') return window.__NEXT_DATA__.props.pageProps?.initialData[key] || defaultFallback;

  return defaultFallback;
};

export { getInitialData };
